Ext.define('SA.ProjectViewsByMode', {
    constructor() {
        this.views = {};
    },

    destroy(mode) {
        var modes = arguments.length === 0 ? ['edit', 'view'] : [mode];

        Ext.destroyMembers(this.views, ...modes);
    },

    destroyViewMode() {
        this.destroy('view');
    },

    get(mode) {
        return this.views[mode];
    },

    getEditModeItem() {
        return this.get('edit').getItem();
    },

    getViewMode() {
        return this.get('view');
    },

    getViewModeItem() {
        return this.getViewMode().getItem();
    },

    has(mode) {
        return Reflect.has(this.views, mode);
    },

    hasViewMode() {
        return !!this.getViewMode();
    },

    set(mode, view) {
        this.views[mode] = view;
    }
});